// import React from "react";
// import "./InfoTooltip.css";
// import image from "./info-icon.png"
// export const InfoTooltip = ({ description, isbutton = true }) => {
//   if (!description) return null;

//   return (
//     <span className="info-wrapper">
//       <span className="info-icon">
//         {isbutton ? <img src={`${image}`} alt="info" /> : <span></span>}
//       </span>
//       {/* <span className="info-tooltip">{description}</span> */}
//       <span className="info-tooltip">
//         {description.split("\n").map((line, index) => (
//           <span key={index}>
//             {line}
//             <br />
//           </span>
//         ))}
//       </span>

//     </span>
//   );
// };
import React from "react";
import "./InfoTooltip.css";
import image from "./info-icon.png";

export const InfoTooltip = ({ description, isbutton = true, last = false }) => {
  if (!description) return null;

  return (
    <span className="info-wrapper">
      <span className="info-icon">
        {isbutton ? <img src={image} alt="info" /> : <span></span>}
      </span>
      <span className={`info-tooltip ${last ? "last" : ""}`}>
        {description.split("\n").map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))}
      </span>
    </span>
  );
};
